export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taker"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maker"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taker ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maker ID"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You Pay"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You Get"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waiting Time"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bank Account/Wallet"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No bank name"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No bank account"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No name provided"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No account provided"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["External"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internal"])}
}